import { APPOINTMENT_EVENT } from '../../modules/Appointments/api/enums/appointment-event';

export const NON_EDITABLE_APPOINTMENT_STATUS_EVENTS = [
  APPOINTMENT_EVENT.CANCELLED,
  APPOINTMENT_EVENT.PROCEDURE_COMPLETE,
  APPOINTMENT_EVENT.POST_OP_FAILURE_TO_PICKUP
];